import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonModal,
  useIonViewDidEnter,
  useIonViewWillLeave,
  IonHeader,
} from "@ionic/react";
import { Holistic } from "@mediapipe/holistic";
import { Camera } from "@mediapipe/camera_utils";
import React, { useEffect, useState } from "react";
import AssessmentCompleteModal from "../components/modals/assessment-complete-modal";
import AssessmentCounter from "../components/modals/assessment-counter";
import LoaderAssesmentModalComponent from "../components/modals/LoaderAssesmentModal";
import PaperPlacementModal from "../components/modals/paper-error-popup";
import ExitConformModal from "../components/modals/PaperPlacementModal";
import FinishIncompleteTestModal from "../components/modals/finish-incomplete-test-modal";
import { useHistory } from "react-router-dom";
import { app, closeApp } from "../movenet";
import { ASSESSMENT_STATUSES } from "../movenet/params";
import RaiseArmModal from "../components/modals/RaiseArmModal";
import { Assessment_Types } from "../vision-algo/assessment_types";

const screenText = [""];

var instructionCounter = 1;

const video = document.createElement("video");
let holistic = new Holistic({
  locateFile: (file: any) => {
    return `https://cdn.jsdelivr.net/npm/@mediapipe/holistic@0.4.1633559476/${file}`;
  },
});
const AssessmentPage: React.FC = () => {
  const [message, setMessage] = useState("");

  //Workaround to Redo the Assessment
  const handleChildClick = (newMessage: any) => {
    setMessage(newMessage);
  };

  useIonViewDidEnter(() => {
    app(Assessment_Types.Fivex_STS);
    console.log("ionViewDidEnter event fired");
  });

  useIonViewWillLeave(() => {
    console.log("ionViewWillLeave event fired");
    closeApp();
  });

  const [assessmentCompleteModalText, setAssessmentCompleteModalText] =
    useState<String>("");
  const [exitModalText, setExitModalText] = useState<String>("");
  const [loaderModalText, setLoaderModalText] = useState<String>("");
  const [showPopupModal, setshowPaperModal] = useState(false);
  const [showCalibrationPopupModal, setshowcalibrationModal] = useState(false);
  const [raiseArm, setRaiseArm] = useState(false);

  let history = useHistory();

  function UpdateText() {
    if (instructionCounter < screenText.length) {
      setnewName(screenText[instructionCounter]);
      instructionCounter++;
    } else {
      //
      instructionCounter = 0;
      setnewName(screenText[instructionCounter]);
      history.push("/angle-adjustment");
    }
  }
  const [UpdateName, setnewName] = useState("");

  const [assessmentCompleteModal, setShowAssessmentCompleteModal] =
    useState(false);
  const [exitConformModal, setShowExitConfirmation] = useState(false);
  const [FinishIncompleteTest, setFinishIncompleteTest] = useState(false);
  const [showFinishIncompleteTestModal, setShowFinishIncompleteTestModal] = useState(false);

  const [assessmentCounter, setShowAssessmentCounterModal] = useState(false);

  const AssessmentStartupMsg = () => {
    setLoaderModalText("Place chair about 8 - 9 ft. away from the device.");
    setshowcalibrationModal(true);
    setTimeout(() => {
      AssessmentStartupMsgContinue();
    }, 2000);
  };
  const AssessmentStartupMsgContinue = () => {
    setLoaderModalText(
      "Make sure that the participant is fully visible in the box while standing"
    );
    setshowcalibrationModal(true);
    setTimeout(() => {
      setshowcalibrationModal(false);
      RaiseArmPopupModal();
    }, 2000);
  };
  const SitDownMsg = () => {
    setLoaderModalText("Now please sit down on a chair, and raise your hand.");
    setshowcalibrationModal(true);
    setTimeout(() => {
      setshowcalibrationModal(false);
    }, 2000);
  };
  const ShowPaperPlacementModal = () => {
    // if ((!showPopupModal) && (localStorage.getItem('CalibrationState') !== '2')) {
    //   //setshowPaperModal(true);
    // }
  };
  const ShowCalibratingModal = () => {};
  const ShowCalibrationCompleteModal = () => {
    try {
      ASSESSMENT_STATUSES.GestureDetectionStart = 1;
      //ASSESSMENT_STATUSES.Shoulder_time='';
      //ASSESSMENT_STATUSES.Direction='';

      /* Closing Paper Placement Modal close if its open
       */
      if (showPopupModal) {
        setshowPaperModal(false);
      }
      /* Closing Raise Arm Modal if its open
       */
      if (raiseArm) {
        setRaiseArm(false);
      }
      setLoaderModalText("CalibrateCompleted");
      setshowcalibrationModal(true);
      setTimeout(() => {
        //closing calibration complete modal
        setshowcalibrationModal(false);
        //WalkBackMsg();
      }, 2000);
    } catch (e) {
      console.log("ShowCalibrationCompleteModal :" + e);
    }
  };

  const WalkBackMsg = () => {};
  const RaiseArmText = () => {
    ASSESSMENT_STATUSES.GestureDetectionStart = 2;
  };
  const CountDownCompleteModal = () => {
    try {
      if (raiseArm) {
        //Closing RaiseArm Modal if its open before opening Counter Modal
        setRaiseArm(false);
      }
      if (!assessmentCounter) {
        setShowAssessmentCounterModal(true);
        setTimeout(() => {
          if (assessmentCounter) {
            setShowAssessmentCounterModal(false);
          }
        }, 4000);
      }
    } catch (e) {
      console.log("CountDownCompleteModal:" + e);
    }
  };
  const AssessmentCompletedModal = () => {
    //setGaitAnalysisCompleted(false);
    if (!assessmentCompleteModal) {
      setAssessmentCompleteModalText("5xSTS ");
      setShowAssessmentCompleteModal(true);
    }
  };
  const RaiseArmPopupModal = () => {
    try {
      setRaiseArm(true);
      setTimeout(() => {
        setRaiseArm(false);
      }, 3000);
    } catch (e) {
      console.log("RaiseArmPopupModal:" + e);
    }
  };

  useEffect(() => {
    app(Assessment_Types.Fivex_STS);
  }, [window.innerWidth, window.innerHeight]);

  return (
    <>
      <button
        className="d-none"
        id="hdnAssessmentStartUpMessage"
        onClick={() => {
          AssessmentStartupMsg();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnSitDownMessage"
        onClick={() => {
          SitDownMsg();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnCalibrationCompletePopup"
        onClick={() => {
          ShowCalibrationCompleteModal();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnWalkBackPopup"
        onClick={() => {
          WalkBackMsg();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnCountDownCompletePopup"
        onClick={() => {
          CountDownCompleteModal();
        }}
      ></button>
      <button
        className="d-none"
        id="hdnAssessmentCompletePopup"
        onClick={() => {
          AssessmentCompletedModal();
        }}
      ></button>
      <>
        <IonModal
          className="loader-popup-modal"
          backdropDismiss={false}
          isOpen={showCalibrationPopupModal}
          placeholder={undefined}
        >
          <LoaderAssesmentModalComponent
            loaderModalText={loaderModalText}
            setloaderModal={setshowcalibrationModal}
          ></LoaderAssesmentModalComponent>
        </IonModal>

        <IonModal
          className="paper-placement-modal"
          backdropDismiss={false}
          isOpen={exitConformModal}
          placeholder={undefined}
        >
          <ExitConformModal
            exitModalText={exitModalText}
            setPaperPlacement={setShowExitConfirmation}
          ></ExitConformModal>
        </IonModal>
        <IonModal
          className="finish-incomplete-test-modal-wrap"
          backdropDismiss={false}
          isOpen={FinishIncompleteTest}
          placeholder={undefined}
        >
          <FinishIncompleteTestModal
            setFinishIncompleteTest={setFinishIncompleteTest}
            setShowFinishIncompleteTestModal={setShowFinishIncompleteTestModal}
            onChildClick={handleChildClick}
          ></FinishIncompleteTestModal>
        </IonModal>
        <IonModal
          className="raise-arm-modal"
          backdropDismiss={false}
          isOpen={raiseArm}
          placeholder={undefined}
        >
          <RaiseArmModal setRaiseArm={setRaiseArm}></RaiseArmModal>
        </IonModal>
        <IonModal
          className="light-error-modal"
          backdropDismiss={false}
          isOpen={showPopupModal}
          placeholder={undefined}
        >
          <PaperPlacementModal
            setShowPaperErrorModal={setshowPaperModal}
          ></PaperPlacementModal>
        </IonModal>
        <IonModal
          className="counter-error-modal"
          backdropDismiss={false}
          isOpen={assessmentCounter}
          placeholder={undefined}
        >
          <AssessmentCounter
            setShowModal3={setShowAssessmentCounterModal}
          ></AssessmentCounter>
        </IonModal>
        <IonModal
          className="assessment-complete-modal"
          backdropDismiss={false}
          isOpen={assessmentCompleteModal}
          placeholder={undefined}
        >
          <AssessmentCompleteModal
            assessmentCompleteModalText={assessmentCompleteModalText}
            setShowModal2={setShowAssessmentCompleteModal}
            onChildClick={handleChildClick}
          ></AssessmentCompleteModal>
        </IonModal>
      </>

      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <div className="assessment-page-wrap">
            <div className="top-header-wrap">
              <div className="top-haeder-sec">
                <IonRow className="row" placeholder={undefined}>
                  <IonCol size="2" className="col-sec" placeholder={undefined}>
                    <div
                      className="left-arrow"
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      <svg
                        width="16"
                        height="26"
                        viewBox="0 0 16 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                          fill="#31344E"
                          stroke="black"
                        />
                      </svg>
                    </div>
                  </IonCol>
                  <IonCol size="8" className="col-sec" placeholder={undefined}>
                    <div className="main-top-heading">
                      <h1>5x STS Assessment</h1>
                    </div>
                  </IonCol>
                  <IonCol size="2" className="col-sec" placeholder={undefined}>
                    <div
                      className="right-cancel-btn"
                      // onClick={() => { history.push("/patient-page") }}
                      // onClick={() => { setShowExitConfirmation(true);setExitModalText("5xSTS "); }}
                      onClick={() => {
                        setFinishIncompleteTest(true);
                      }}
                    >
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 31C24.5081 31 31 24.5081 31 16.5C31 8.49187 24.5081 2 16.5 2C8.49187 2 2 8.49187 2 16.5C2 24.5081 8.49187 31 16.5 31Z"
                          fill="white"
                          stroke="#31344E"
                          strokeWidth="3.22222"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21.3333 21.3332L11.6667 11.6667"
                          stroke="#31344E"
                          strokeWidth="3.22222"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21.3334 11.6667L11.6667 21.3333"
                          stroke="#31344E"
                          strokeWidth="3.22222"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </IonCol>
                </IonRow>
              </div>
            </div>
          </div>
        </IonHeader>
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container assessment-page-wrap-container"
            placeholder={undefined}
          >
            <div className="assessment-page-wrap">
              {/* <div className="assessment-video-wrap" onClick={() => setShowModal2(true)}> */}

              <div id="stats" style={{ display: "none" }}></div>
              <div className="assessment-video-wrap">
                <div id="main">
                  <div className="canvas-wrapper">
                    <canvas id="output"></canvas>
                    <video
                      id="video"
                      playsInline
                      autoPlay={true}
                      muted
                      style={{
                        transform: "scaleX(-1)",
                        visibility: "hidden",
                        width: "auto",
                        height: "auto",
                      }}
                    >
                      {/* <source src="videos/IMG_5547.MOV" type="video/mp4" /> */}
                      <source
                        src="videos/SitStand_Multi.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <div id="scatter-gl-container"></div>
                </div>
              </div>
            </div>
            <audio
              id="audio-paper-placement"
              src="audios/paper_placement.mp3"
              preload="auto"
            >
              <source />
            </audio>
          </IonGrid>
        </IonContent>
      </IonPage>
    </>
  );
};

export default AssessmentPage;
//
